<template>
  <div>

    <div class="row">
      <div class="col-lg-3 col-sm-6" v-for="review in reviews">
        <review-card :review-id="review.id">
          <div slot="video-link-thumb">
            <img :src="review.thumbnailUrl" :alt="review.title" style="display: block; width: 150px; margin-left: auto; margin-right: auto;" />
          </div>
          <div slot="title">
            {{review.title}}
          </div>
        </review-card>
      </div>
    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  import ReviewCard from 'src/components/UIComponents/Cards/ReviewCard.vue'

  export default {
    components: {
      ReviewCard
    },
    data () {
      return {
        reviews: []
      }
    },
    methods: {
      fetchReviews: function (businessId) {
        this.$http.get('https://api.vyoo.io/v1/business/' + businessId + '/reviews')
        .then(function (response) {
          console.log(response.data)
          // this.reviews = response.data;
        })
      },
      fetchReviewsPlaceholder: function (businessId) {
        axios.get('http://jsonplaceholder.typicode.com/photos?albumId=1')
        .then((response) => {
          console.log(response.data)
          this.reviews = response.data
        })
      }
    },
    created: function () {
      // this.fetchProduct('b2:11058216522')
      // this.fetchFeaturedReviews('b2', 'MyFirstGroup');
      // this.fetchReviews('b2')
      this.fetchReviewsPlaceholder()
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Reviews.vue